var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.data),function(item,index){return _c(item,{key:index,tag:"component"})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }